import { Strapi4ResponseMany, Strapi4ResponseSingle } from "@nuxtjs/strapi";
import { StrapiImage, StrapiSingleType } from "~/types/strapi";
import { CmsCategory } from "~/types/strapi/collection-types/CmsCategory";

export enum CmsPageType {
  blog = "blog",
  info = "info",
}

export interface CmsPage extends StrapiSingleType {
  id: number;
  title: string;
  slug: string;
  type: CmsPageType;
  image?: Strapi4ResponseSingle<StrapiImage>;
  cms_category?: Strapi4ResponseSingle<CmsCategory>;
  subtitle?: string;
  content?: string;
  relatedCategoriesUids?: string[];
  relatedProductsSkus?: string[];
  relatedCmsPages?: Strapi4ResponseMany<CmsPage>;
  publishedAt: string;
}
